import { apiFetch } from '@/lib/api';

export interface TagDelta {
    add?: string[];
    remove?: string[];
}

export async function saveAssetTags(
    showId: string,
    assets: any[],
    { add = [], remove = [] }: TagDelta,
): Promise<any[]> {
    return Promise.all(assets.map(async (asset: any) => {
        const current = Array.isArray(asset.tags) ? asset.tags : [];
        const nextTags = Array.from(new Set([
            ...current.filter((id: string) => !remove.includes(id)),
            ...add,
        ]));
        const response = await apiFetch(`/api/shows/${showId}/assets/${asset._id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ tags: nextTags }),
        });
        if (!response.ok) throw new Error(`Failed to update tags for asset ${asset._id}`);
        return response.json();
    }));
}
